import { FC, ReactElement } from 'react';
import { Box, Flex, Link, LinkProps } from '@chakra-ui/react';
import NextLink from 'next/link';
export interface CbNavigationLinkProps extends LinkProps {
  href?: string;
  isActive: boolean;
  icon?: ReactElement;
  isMobile?: boolean;
  renderAsButton?: boolean;
}
export const CbNavigationLink: FC<CbNavigationLinkProps> = ({
  as,
  children,
  href,
  icon,
  isActive,
  isExternal,
  isMobile,
  renderAsButton = false,
  onClick,
  ...props
}) => {
  const linkColor = isMobile ? 'luigisPants.500' : 'cloud.500';
  const linkActiveColor = isMobile ? 'chonky.500' : 'white';
  const getChakraLink = (as?: any, href?: string) => <Link as={as} aria-current={isActive ? 'page' : undefined} color={isActive ? linkActiveColor : linkColor} display="block" fontFamily="codenext" fontSize="sm" isExternal={isExternal} paddingX={isMobile ? '22px' : '25px'} paddingY="18px" textAlign="left" _hover={{
    color: linkActiveColor,
    textDecoration: 'none'
  }} _focus={{
    color: linkActiveColor,
    textDecoration: 'none'
  }} onClick={e => onClick && onClick(e)} {...props} data-sentry-element="Link" data-sentry-component="getChakraLink" data-sentry-source-file="CbNavigationLink.tsx">
      <Flex alignItems="center" data-sentry-element="Flex" data-sentry-source-file="CbNavigationLink.tsx">
        {icon && <Box marginRight={3} paddingBottom="2px">
            {icon}
          </Box>}
        {children}
      </Flex>
    </Link>;
  if (as) {
    return getChakraLink(as, href);
  }
  if (href) {
    return <NextLink passHref href={href as string} legacyBehavior>
        {getChakraLink()}
      </NextLink>;
  }
  return getChakraLink(renderAsButton ? 'button' : undefined, href);
};